import { RouteObject } from 'react-router-dom';
import { homeRoutes } from './home';
import { userRoutes } from './user';
import { vendorRoutes } from './vendor';

const routes: RouteObject[] = [...homeRoutes, ...userRoutes, ...vendorRoutes];

export default routes;
